export default __webpack_public_path__ + "static/media/prayed4.14e3783b.png";